module.exports = new __parcel__URL__("olive.3e3e2c53.svg").toString();